import React, { ReactNode } from 'react';
import { defineMessage } from 'react-intl';

import { NavigationBar, Page, PageContent } from '@ocx/ui';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';
import { BottomNavigationController } from '@ocx-app/pages/Home/components/BottomNavigationController';

type OrderAheadLayoutProps = {
  children: ReactNode;
};

export const OrderAheadLayout = (props: OrderAheadLayoutProps) => {
  const { children } = props;
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'orderAhead:htmlTitle',
          defaultMessage: 'Order Ahead',
          description: 'HTML title tag for Order Ahead Page',
        })}
      />
      <NavigationBar left={<BackButton />} center={<VendorLogo />} />
      <PageContent bgcolor="background.paper" overflow="hidden">
        {children}
      </PageContent>
      <BottomNavigationController />
    </Page>
  );
};
